// product_prices/ProductPriceRow.js
import React               from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { formatNumber }    from '../quotes/form/helpers'

const ProductPriceRow = ({
  productPrice,
  isEditing,
  editValue,
  editDiscount,
  onStartEdit,
  onEditChange,
  onDiscountChange,
  onCancelEdit,
  onSaveEdit,
  onDelete
}) => {
  const { product, sale_price, discount } = productPrice

  const handleDelete = () => {
    if (window.confirm(I18n.t('button.sure'))) {
      onDelete()
    }
  }

  return (
    <>
      {/* 1. Reference */}
      <div className="pl-2">
        <ProductLink product={product}>{product.ref_brand}</ProductLink>
      </div>

      {/* 2. Designation */}
      <div className="pl-2">
        <ProductLink product={product}>{product.designation}</ProductLink>
      </div>

      {/* 3. Unit */}
      <div className="text-center">{product.unit}</div>

      {/* 4. Purchase price */}
      <div className="text-right pr-2">
        {formatNumber(product.purchase_price.amount)}
      </div>

      {/* 5. Catalogue price */}
      <div className="text-right pr-2">
        {formatNumber(product.sale_price.amount)}
      </div>

      {/* 6, 7 & 8. Client price / discount / actions */}
      {isEditing ? (
        <>
          {/* client price input */}
          <div className="text-right pr-2">
            <input
              className="form-control text-right"
              type="number"
              step="0.01"
              value={editValue}
              onChange={e => onEditChange(e.target.value)}
            />
          </div>

          {/* discount input */}
          <div className="text-right pr-2">
            <input
              className="form-control text-right"
              type="number"
              step="0.01"
              value={editDiscount}
              onChange={e => onDiscountChange(e.target.value)}
            />
          </div>

          {/* cancel / save icons */}
          <div className="text-center">
            <span className="icon-wrapper" onClick={onCancelEdit}>
              <FontAwesomeIcon icon="times-circle" />
            </span>
            <span className="icon-wrapper" onClick={onSaveEdit}>
              <FontAwesomeIcon icon="check-circle" className="save" />
            </span>
          </div>
        </>
      ) : (
        <>
          {/* client price, click to edit */}
          <div className="text-right pr-2 clickable" onClick={onStartEdit}>
            {formatNumber(sale_price.amount)}
          </div>

          {/* discount, click to edit */}
          <div className="text-right pr-2 clickable" onClick={onStartEdit}>
            {discount ? `${formatNumber(discount)} %` : '—'}
          </div>

          {/* edit / delete icons */}
          <div className="text-center">
            <span className="icon-wrapper" onClick={onStartEdit}>
              <FontAwesomeIcon icon="edit" />
            </span>
            <span className="icon-wrapper delete" onClick={handleDelete}>
              <FontAwesomeIcon icon="trash" className="delete" />
            </span>
          </div>
        </>
      )}
    </>
  )
}

const ProductLink = ({ children, product }) => (
  <a
    data-toggle="modal"
    data-target="#remote-modal"
    data-action="click->modal#show"
    data-route={product.path}
  >
    {children}
  </a>
)

export default ProductPriceRow
